import { lazy } from 'react';

import type { RouteObject } from 'react-router-dom';

/**
 * Rotas do módulo de conteúdo — **todas públicas, sem guard**.
 *
 * Guia de enchente e telefone de emergência são o conteúdo que mais precisa
 * chegar a quem ainda não tem conta (P2). Um convidado que abre o app com a
 * água subindo tem que conseguir ler "ligue 193" sem passar por cadastro.
 *
 * As quatro seções têm rota própria, e não são abas de uma tela só: cada uma é
 * compartilhável por link — que é como conteúdo de crise circula de verdade,
 * colado num grupo de mensagens.
 *
 * `content/guides/:slug` fica **depois** da lista por clareza; o react-router
 * já ranqueia o segmento estático acima do dinâmico, então a ordem aqui é
 * documentação, não comportamento.
 */

const ContentPage = lazy(() => import('./routes/Content.page'));
const GuidesPage = lazy(() => import('./routes/Guides.page'));
const GuideCategoryPage = lazy(() => import('./routes/GuideCategory.page'));
const GuidePage = lazy(() => import('./routes/Guide.page'));
const EmergencyContactsPage = lazy(() => import('./routes/EmergencyContacts.page'));
const OfficialLinksPage = lazy(() => import('./routes/OfficialLinks.page'));
const OrganizationsPage = lazy(() => import('./routes/Organizations.page'));

export const contentRoutes: RouteObject[] = [
  { path: 'content', element: <ContentPage /> },
  { path: 'content/guides', element: <GuidesPage /> },
  { path: 'content/guides/category/:category', element: <GuideCategoryPage /> },
  { path: 'content/guides/:slug', element: <GuidePage /> },
  { path: 'content/emergency-contacts', element: <EmergencyContactsPage /> },
  { path: 'content/official-links', element: <OfficialLinksPage /> },
  { path: 'content/organizations', element: <OrganizationsPage /> },
];
